import { useMediaQuery } from "@mantine/hooks";

import { ApplicationLimitTable } from "@/components/model/user/ApplicationLimitTable";
import { IncentiveTable } from "@/components/model/user/IncentiveTable";
import { PenaltyTable } from "@/components/model/user/PenaltyTable";
import { PointSystemExplanation } from "@/components/model/user/PointSystemExplanation";
import { Modal, Stack } from "@/components/ui/elements";

type Props = {
  opened: boolean;
  close: () => void;
};

export function WorkerPointModal({ opened, close }: Props) {
  const isMobile = useMediaQuery("(max-width: 50em)");

  return (
    <Modal opened={opened} close={close} fullScreen={isMobile}>
      <Stack py="md">
        <PointSystemExplanation />
        <PenaltyTable />
        <IncentiveTable />
        <ApplicationLimitTable />
      </Stack>
    </Modal>
  );
}
